import { Radio, Typography } from 'antd'

type Props = {
  label: string
  description: string
  checked: boolean
  onClick: () => void
}

const RadioOption = ({ label, description, checked, onClick }: Props) => {
  return <div onClick={onClick} style={{ cursor: 'pointer' }}>
    <Radio checked={checked}>{label}</Radio>
    <div style={{ marginLeft: '24px' }}>
      <Typography.Text type="secondary">{description}</Typography.Text>
    </div>
  </div>
}

export default RadioOption
